import { render, staticRenderFns } from "./MaterialDeleteList.vue?vue&type=template&id=7567c2a4&scoped=true"
import script from "./MaterialDeleteList.vue?vue&type=script&lang=js"
export * from "./MaterialDeleteList.vue?vue&type=script&lang=js"
import style0 from "./MaterialDeleteList.vue?vue&type=style&index=0&id=7567c2a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567c2a4",
  null
  
)

export default component.exports